import * as urls from "../../api/scheduler/url";
import { getRequest } from "../../../services/RestServices";

export const getInstallers = async (vendorId) => {
  try {
    return await getRequest(urls.FETCH_INSTALLERS_LIST + `/${vendorId}`);
  } catch (err) {
    return err;
  }
};
